<template>
  <article>
    <h1 class="title-black">this</h1>
    <blockquote
      cite="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/this">
      A property of an execution context (global, function or eval) that, in
      non-strict mode, is always a reference to an object and in strict mode
      can be any value.<br />
      ~ MDN
    </blockquote>
    <p>
      under construction
    </p>
  </article>
</template>

<script>
export default {
  name: 'home',
}
</script>
